<div class="modal-header">
    <h5 class="modal-title text-center ml-auto mr-auto">{{ 'select_current_rp' | translate: lang }}</h5>
    <button (click)="modalService.closeOutletModals('public')" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
    </button>
</div>
<div class="modal-body">
  <div class="elems">
    <div class="elem" *ngFor="let lp of lps[rankName]" (click)="onSelect(lp.minLp)">
      <p class="text-mon mt-2 text-center">{{lp.minLp}}-{{lp.maxLp}}</p>
    </div>
  </div>
</div>
